import * as actionTypes from '../actions/ActionTypes'

export default function(state = [], action) {
  switch (action.type) {
    case actionTypes.LISTS_CALL_IN_TYPE_UPDATE:
      return action.listsCallInType
    default:
      return state
  }
}